// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1aadaeba","879":"5a23ab31"}[chunkId] + ".chunk.js";
};